import { FiBox, FiX } from 'react-icons/fi'
import Router from 'next/router'
import useSWR from 'swr'
import dayjs from 'dayjs'
import fetcher from '@byma/shared/helpers/fetcher'
import Loader from '@byma/shared/components/Loader'
import Input from '@byma/shared/components/Input'
import React from 'react'

function StatusItem({status, active=false}) {
    return (
        <div className={`flex items-center cursor-pointer box box-hover ${active && 'box-active'} gap-3`}>
            <input type="checkbox" checked={active} readOnly />
            <div className="">
                <p className="text-md font-bold">{status?.label}</p>
            </div>
        </div>
    )
}

const DEFAULT_STATUS = [{
    key: 'paid',
    label: 'Pago',
}, {
    key: 'refunded',
    label: 'Estornado',
}, {
    key: 'under_analysis',
    label: 'Sob análise',
}]

export default function StatusFilter({ token, filteredStatus=[], status = DEFAULT_STATUS }) {
    const [statusFilterOpen, setStatusFilterOpen] = React.useState(false);
    const [selectedStatus, setSelectedStatus] = React.useState([])

    React.useEffect(() => {
        if (filteredStatus) {
            setSelectedStatus(typeof filteredStatus === 'string' ? [filteredStatus] : filteredStatus)
        }
    }, [filteredStatus])

    function handleSelect(status) {
        if (selectedStatus.indexOf(status.key) >= 0) {
            setSelectedStatus(selectedStatus.filter(e => e !== status.key))
        } else {
            setSelectedStatus([...selectedStatus, status.key])
        }
    }

    function handleFilter() {
        let url = new URL(window.location.href)
        let searchParams = url.searchParams
        searchParams.delete('st')
        selectedStatus.forEach(event => searchParams.append('st', event))
        url.search = searchParams.toString()
        Router.push(url.toString())
        setStatusFilterOpen(false)
    }

    return (
        <div className="">
            <button className="flex justify-between items-center cursor-pointer rounded shadow px-2 py-1 text-sm hover:shadow-md whitespace-nowrap space-x-1 focus:shadow-sm" onClick={() => setStatusFilterOpen(!statusFilterOpen)}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
                {selectedStatus.length > 0 ? (
                    <p>
                        {selectedStatus.length} status 
                    </p>
                ) : (
                    <p>
                        Todos os status
                    </p>
                )}
            </button>
            <div className={`fixed w-full h-full inset-0 transition-opacity duration-100 ${statusFilterOpen ? 'z-50 opacity-100' : '-z-1 opacity-0'}`} onClick={() => setStatusFilterOpen(false)}>
                <div class="absolute w-full h-full bg-gray-900 opacity-50" />
                <div class="modal-content absolute bg-white w-full md:w-11/12 md:max-w-md md:mx-auto md:rounded md:shadow-lg z-50 md:h-1/2 h-full" onClick={(e) => e.stopPropagation()}>
                    <div className="flex flex-col justify-between p-3 space-y-3 h-full">
                        <div className="">
                            <div className="flex justify-between items-center mb-3">
                                <div className="">
                                    <p className="font-bold text-xl">Filtrar por status</p>
                                </div>
                                <div className="cursor-pointer" onClick={() => setStatusFilterOpen(false)}>
                                    <FiX size={24}/>
                                </div>
                            </div>
                        </div>
                        <div className="overflow-y-auto flex-grow flex-shrink">
                            <div className="flex flex-col">
                                { status ? status.map(status => (
                                    <div onClick={() => handleSelect(status)}>
                                        <StatusItem status={status} active={selectedStatus.indexOf(status.key) >=0} />
                                    </div>
                                )) : <Loader />}
                            </div>
                        </div>
                        <div className="flex space-x-2">
                            {selectedStatus.length === 0 ? (
                                <button className="btn btn-primary w-full" onClick={handleFilter}>Remover filtro de status</button>
                            ) : (
                                <>
                                <button className="btn btn-primary w-full" onClick={handleFilter}>Filtrar {selectedStatus.length} status</button>
                                    <button className="btn btn-white w-full" onClick={() => setSelectedStatus([])}>Limpar sele&ccedil;&atilde;o</button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
